export interface KeyedItem<T> {
  key: string;
  item: T;
}

/**
 * Erzeugt stabile React-Keys für Listen ohne eigene Identität (Sonar S6479).
 * Duplikate erhalten einen Zähler-Suffix, damit die Keys eindeutig bleiben.
 */
export function toKeyedItems<T>(items: T[], getBaseKey: (item: T) => string = String): KeyedItem<T>[] {
  const occurrences = new Map<string, number>();
  return items.map(item => {
    const baseKey = getBaseKey(item);
    const count = occurrences.get(baseKey) ?? 0;
    occurrences.set(baseKey, count + 1);
    return { key: count === 0 ? baseKey : `${baseKey}-${count}`, item };
  });
}
